import { useMemo } from 'react'
import type { DesignPersonalizationContext } from '@vp/personalization-types'
import { useSchemeContext } from './useSchemeContext'

interface UseSchemeImagesResult {
  images: NonNullable<DesignPersonalizationContext['images']>
  logos: NonNullable<DesignPersonalizationContext['images']>
  photos: NonNullable<DesignPersonalizationContext['images']>
  hasImages: boolean
  hasLogo: boolean
  hasPhoto: boolean
}

export const useSchemeImages = (schemeId: string): UseSchemeImagesResult => {
  const { contextData } = useSchemeContext(schemeId)

  const images = useMemo(() => contextData?.images ?? [], [contextData])
  const logos = useMemo(() => images?.filter((image) => image?.purpose === 'logo'), [images])
  const photos = useMemo(() => images?.filter((image) => image?.purpose === 'photo'), [images])
  const hasImages = useMemo(() => images.length > 0, [images.length])
  const hasLogo = useMemo(() => logos.length > 0, [logos.length])
  const hasPhoto = useMemo(() => photos.length > 0, [photos.length])

  return {
    images,
    logos,
    photos,
    hasImages,
    hasLogo,
    hasPhoto,
  }
}
